import { render, staticRenderFns } from "./sela_concept_detail.vue?vue&type=template&id=399b27dc&scoped=true"
import script from "./sela_concept_detail.vue?vue&type=script&lang=js"
export * from "./sela_concept_detail.vue?vue&type=script&lang=js"
import style0 from "./sela_concept_detail.vue?vue&type=style&index=0&id=399b27dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399b27dc",
  null
  
)

export default component.exports